import React from "react"
import type { CustomFieldUrl } from "@love-irish/types"
import { Badge } from "@love-irish/ui-components"

const UrlField = ({ field }: { field: CustomFieldUrl }) => {
  if (!field.value) return null

  return (
    <Badge variant="outline">
      <strong className="mr-1">{field.label}:</strong>{" "}
      <a
        href={field.value}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-primary"
      >
        View →
      </a>
    </Badge>
  )
}

export default UrlField
